(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  function labelJudgeMeArrows(root) {
    var scope = root || document;
    var arrows = scope.querySelectorAll('.jdgm-arrow');
    for (var i = 0; i < arrows.length; i++) {
      var arrow = arrows[i];
      var isNext = arrow.classList.contains('jdgm-next-arrow') || /next/i.test(arrow.getAttribute('onclick') || '');
      var label = isNext ? 'Next review' : 'Previous review';
      arrow.setAttribute('aria-label', label);
      if (!arrow.getAttribute('title')) arrow.setAttribute('title', label);
      var text = (arrow.textContent || '').trim();
      if (!text) arrow.innerHTML = '<span aria-hidden="true">' + (isNext ? '→' : '←') + '</span>';
    }
  }

  function improveAccordionButtons(root) {
    var scope = root || document;
    var triggers = scope.querySelectorAll('.accordion-trigger');
    for (var i = 0; i < triggers.length; i++) {
      var trigger = triggers[i];
      if (!trigger.getAttribute('aria-label')) {
        trigger.setAttribute('aria-label', (trigger.textContent || 'Toggle answer').trim());
      }
    }
  }

  function improveStaticCategoryCards(root) {
    var scope = root || document;
    var cards = scope.querySelectorAll('.tb-cat-card--static');
    for (var i = 0; i < cards.length; i++) {
      cards[i].setAttribute('role', 'group');
      cards[i].setAttribute('aria-label', 'Category coming soon');
    }
  }

  function improveSlickControls(root) {
    var scope = root || document;
    var prevButtons = scope.querySelectorAll('.slick-prev:not([aria-label])');
    for (var i = 0; i < prevButtons.length; i++) {
      prevButtons[i].setAttribute('aria-label', 'Previous slide');
      if (!prevButtons[i].getAttribute('title')) prevButtons[i].setAttribute('title', 'Previous slide');
    }

    var nextButtons = scope.querySelectorAll('.slick-next:not([aria-label])');
    for (var j = 0; j < nextButtons.length; j++) {
      nextButtons[j].setAttribute('aria-label', 'Next slide');
      if (!nextButtons[j].getAttribute('title')) nextButtons[j].setAttribute('title', 'Next slide');
    }

    var dots = scope.querySelectorAll('.slick-dots li button');
    for (var k = 0; k < dots.length; k++) {
      var button = dots[k];
      var label = 'Go to slide ' + (k + 1);
      button.setAttribute('aria-label', label);
      if (!button.getAttribute('title')) button.setAttribute('title', label);
    }
  }

  function improveMobileFacetButtons(root) {
    var scope = root || document;
    var buttons = scope.querySelectorAll('[data-mobile-facets-close="true"]');
    for (var i = 0; i < buttons.length; i++) {
      if (!buttons[i].getAttribute('aria-label')) {
        buttons[i].setAttribute('aria-label', (buttons[i].textContent || 'Apply filters').trim());
      }
    }
  }

  function run(root) {
    labelJudgeMeArrows(root);
    improveAccordionButtons(root);
    improveStaticCategoryCards(root);
    improveSlickControls(root);
    improveMobileFacetButtons(root);
  }

  function closeMobileFacetsPanel(button) {
    if (!button) return;
    var wrapper = button.closest('.mobile-facets__wrapper');
    if (!wrapper) return;

    var summary = wrapper.querySelector('summary');
    if (summary) {
      summary.click();
    }
  }

  document.addEventListener('click', function (event) {
    var closeButton = event.target.closest('[data-mobile-facets-close="true"]');
    if (closeButton) {
      closeMobileFacetsPanel(closeButton);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(document); });
  } else {
    run(document);
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];
      for (var j = 0; j < mutation.addedNodes.length; j++) {
        var node = mutation.addedNodes[j];
        if (node && node.nodeType === 1) run(node);
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function () { observer.disconnect(); }, 8000);
})();
